import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'fitmentListingTireNotes',
  title: 'Fitment Listing Tire Notes',
  type: 'object',
  fields: [
    defineField({
      name: 'tireNotes',
      title: 'Tire Notes',
      type: 'object',
      options: {
        collapsible: true,
        collapsed: false,
      },
      fields: [
        {
          name: 'selectedNotes',
          title: 'Select predefined notes',
          type: 'array',
          of: [
            {
              type: 'reference',
              to: [{ type: 'tireNote' }],
              options: {
                //@ts-ignore - hideTitle is not in the types but is valid
                hideTitle: true,
                disableNew: true,
              },
            },
          ],
        },
        {
          name: 'extraTireNotes',
          title: 'Extra tire notes',
          description:
            'Use this field if you want to add notes that are specific to this listing.',
          type: 'array',
          of: [
            {
              type: 'object',
              name: 'extraNote',
              title: 'Note',
              fields: [
                {
                  name: 'content',
                  title: 'Content',
                  type: 'array',
                  of: [
                    {
                      type: 'block',
                      styles: [{ title: 'Normal', value: 'normal' }],
                      marks: {
                        decorators: [
                          { title: 'Strong', value: 'strong' },
                          { title: 'Emphasis', value: 'em' },
                        ],
                        annotations: [
                          {
                            name: 'link',
                            type: 'object',
                            fields: [
                              {
                                name: 'href',
                                type: 'url',
                                title: 'URL',
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    }),
  ],
})
